module.exports = {
  name: 'Toolbar',
  props: ['logo'],
  data: () => ({
    checked: false,
    userName: null,
    userAvatar: null
  }),
  methods: {
    signIn() {
      this.$router.replace('/login');
    },
    signOut() {
      this.$auth.signOut();
      window.location.href = '/';
    },
    drawerClick() {
      this.$emit('drawer', true);
    },
    setLanguage(lang) {
      this.$i18n.locale = lang;
      this.$cookie.set('lang', lang);
    }
  },
  computed: {
    toolbarTitle() {
      return this.$route.params.mac || this.$t(this.$route.name) || this.$t('app_name');
    },
    toolbarIsBackIcon() {
      return this.$route.meta.up;
    },
    currentLocale() {
      return this.$t('lang.' + this.$i18n.locale);
    },
    localeList() {
      return Object.keys(this.$i18n.messages).filter(key => key != this.$i18n.locale);
    }
  },
  mounted() {
    let unsubscribe = this.$auth.onAuthStateChanged(user => {
      unsubscribe();
      this.checked = true;
      if (user) {
        this.userName = user.displayName;
        this.userAvatar = user.photoURL;
      }
    })
  },
  template: `
<v-toolbar dark color="primary" app>
  <v-btn icon v-if="toolbarIsBackIcon" @click="$router.go(-1)">
    <v-icon>arrow_back</v-icon>
  </v-btn>
  <v-toolbar-side-icon v-else @click="drawerClick"></v-toolbar-side-icon>
  <img width="36" height="36" :src="logo" class="ml-4 hidden-xs-only" />
  <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
  <v-spacer></v-spacer>
  <slot></slot>
  <v-toolbar-items class="hidden-xs-only">
    <v-menu offset-y>
      <v-btn slot="activator" flat>
        <div><span class="caption">language</span><br><span>{{ $t('lang.' + $i18n.locale) }}</span></div>
      </v-btn>
      <v-list>
        <v-list-tile v-for="(item, index) in localeList" :key="index" @click="setLanguage(item)">
          <v-list-tile-title>{{ $t('lang.' + item) }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar-items>
  <v-toolbar-items>
    <v-btn flat v-on:click="signIn" v-if="checked && !userName">{{ $t('toolbar.login' )}}</v-btn>
  </v-toolbar-items>
  <v-tooltip bottom v-if="checked && userName">
    <v-btn flat v-on:click="signOut" slot="activator" icon>
      <v-avatar :size="36"><img :src="userAvatar"></v-avatar>
    </v-btn>
    <span>{{ userName }}</span>
  </v-tooltip>
</v-toolbar>
  `
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/Toolbar.js
// module id = WLim
// module chunks = 0